import recoverPassword from '@/components/User/recoverPassword/recoverPassword.vue'
import { async } from 'q';
import alerts from '@/components/Alert/Alert.vue'

export default {
  name: 'Login',

  components: {
    recoverPassword,
    alerts
  },

  data() {
    return{

      modal_recoverPassword: false,

      alert_temp: {
        status: false,
        label: "",
        type: ""
      },

      dLogin: {
        email: "",
        password: ""
      },

      items: [
        {
            'id':'1',
            'title': 'hello',
            'description': 'ok ok',
            'created_date': '2018-09-09'
        },
        {
            'id':'2',
            'title': 'hello 2',
            'description': 'ok ok 2',
            'created_date': '2018-10-09'
        }
    ],
    columns: [ 'id', 'title', 'description', 'created_date'],

    footer: {
      made: 'Made with ❤ in Guadalajara',
      sign: 'A Design Partner for Digital Business'
    }

    }
  },

  methods: {
    init_login(){
      (async () => {
        this.dLogin.email = this.dLogin.email.toLowerCase();
        var fetchRes = await fetch('https://sandbox.api.salonacme.com/manager/login', {
          method: 'POST',
          headers:{
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.dLogin)
        }).then(async response => {
          response = await response.json();
          if(response.status)
          {
            // Generationg Session
            await this.$session.destroy();
            this.$session.set('_id',response.session._id);
            this.$session.set('name',response.session.name);
            this.$session.set('email',response.session.email);
            this.$session.set('type',response.session.type);
            this.$session.set('accessToken',response.session.accessToken);
            this.$session.set('_aws_url',response.session._aws_url);
            this.$session.set('_aws_url_file',response.session._aws_url + response.session.actual_edition + "/" );
            this.$session.start();
            this.$parent.$forceUpdate(); 
            if(response.session.type == 'admin')
              this.$router.push('/opencall_admin');
            else
              this.$router.push('/opencall');

          }else{
            /** Alert */
            this.alert_temp = { status: true,
              type: "warning",
              label: response.msg
            };
            setTimeout(() => {this.alert_temp.status = false;}, 3000);
            /** FIN Alerta */
          }
          
        })
        .catch(error => console.log(error))
        // console.log(fetchRes.json());

      })();
    }
  }

  
}
